import api from "../api/axiosInstance";

const userService = {
  getAll: (params) => api.get("/users", { params }),
  getOne: (id) => api.get(`/users/${id}`),
  create: (data) => api.post("/users", data),
  update: (id, data) => api.patch(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  // Bulk-mark/unmark accounts as having authorized Waypoint Imports as
  // their Agent on the COLS customs portal — see AdminCustomers.jsx's
  // bulk selection toolbar. Pass exactly one of userIds/tins.
  bulkSetWaypointAgent: ({ userIds, tins, isWaypointImportsAgent }) =>
    api.patch("/users/bulk-update", { userIds, tins, isWaypointImportsAgent }),
  changePassword: (data) => api.patch("/auth/change-password", data),
  getPhotoUploadUrl: (file) =>
    api.post("/users/me/photo-upload-url", { name: file.name, type: file.type, size: file.size }),
  setPhoto: (key) => api.post("/users/me/photo", { key }),
  removePhoto: () => api.delete("/users/me/photo"),
  // One-time only — server rejects this once referralCode is already set.
  setReferralCode: (referralCode) => api.patch("/users/me/referral-code", { referralCode }),
  joinReferralWaitlist: (email) => api.post("/users/me/referral-waitlist", { email }),
  // Admin visibility into the referral program ahead of actually launching
  // it — who's on the "notify me" waitlist, and who's already claimed a
  // referral code.
  getReferralWaitlist: () => api.get("/users/referral-waitlist"),
  getReferralCodes: () => api.get("/users/referral-codes"),
  // The logged-in customer's own credit balance + referrals they made.
  getMyReferralSummary: () => api.get("/users/me/referral-summary"),
  // Admin — the real referral ledger (replaces visibility-only referral codes).
  getReferrals: (status) => api.get("/users/referrals", { params: { status } }),
  voidReferral: (id, reason) => api.patch(`/users/referrals/${id}/void`, { reason }),
  deleteReferral: (id) => api.delete(`/users/referrals/${id}`),
  getReferralProgramSettings: () => api.get("/users/referral-program-settings"),
  updateReferralProgramSettings: (data) => api.patch("/users/referral-program-settings", data),
};

export default userService;
